import script from "./MailSenderDetails.vue?vue&type=script&setup=true&lang=js"
export * from "./MailSenderDetails.vue?vue&type=script&setup=true&lang=js"

import "./MailSenderDetails.vue?vue&type=style&index=0&id=413f4d00&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-413f4d00"]])

export default __exports__